import { formValueSelector } from 'redux-form';
import { CABIN_UPGRADE } from '../../products';
export const validateCabinUpgradeAvailabilityTexts = availabilityTexts => {
  const {
    availabilityCard = null,
    drawer = null
  } = availabilityTexts;
  if (!availabilityCard || !drawer) {
    return false;
  }
  const {
    availabilityTitle,
    availableStatus,
    changeUpgradeLabel,
    statusTooltip,
    unavailableStatus
  } = availabilityCard;
  const {
    checkboxSelectionLabel,
    drawerAdditionalContentText,
    drawerCardFlightDuration,
    drawerCardSelectionTitle,
    drawerSaveButtonLabel,
    drawerTitle,
    drawerTotalPriceLabel,
    perPersonLabel
  } = drawer;
  const validateAvailabilityCardTexts = Boolean(availabilityTitle && availableStatus && changeUpgradeLabel && unavailableStatus && statusTooltip);
  const validateAvailabilityDrawerTexts = Boolean(checkboxSelectionLabel && drawerAdditionalContentText && drawerCardFlightDuration && drawerCardSelectionTitle && drawerSaveButtonLabel && drawerTitle && drawerTotalPriceLabel && perPersonLabel);
  return validateAvailabilityCardTexts && validateAvailabilityDrawerTexts;
};
export const extractSegmentData = (segmentUpgrade, availabilityTexts) => {
  const {
    availableStatus,
    unavailableStatus
  } = availabilityTexts === null || availabilityTexts === void 0 ? void 0 : availabilityTexts.availabilityCard;
  const destinationLabel = availabilityTexts === null || availabilityTexts === void 0 ? void 0 : availabilityTexts.destinationLabel;
  const {
    origin,
    destination,
    upgradeOptions
  } = segmentUpgrade;
  const isSegmentAvailable = Boolean(upgradeOptions && (upgradeOptions === null || upgradeOptions === void 0 ? void 0 : upgradeOptions.length));
  let originDestinationAirportAriaLabelText = '';
  let flightRoute = {};
  const {
    cityName: originAirportName,
    name: originAirportFullName,
    code: originAirportCode
  } = origin;
  const {
    cityName: destinationAirportName,
    name: destinationAirportFullName,
    code: destinationAirportCode
  } = destination;
  const availabilityStatusText = isSegmentAvailable ? availableStatus : unavailableStatus;
  originDestinationAirportAriaLabelText = `${originAirportFullName} ${destinationLabel} ${destinationAirportFullName} ${availabilityStatusText}`;
  flightRoute = {
    originAirportName,
    originAirportCode,
    destinationAirportName,
    destinationAirportCode
  };
  return {
    isSegmentAvailable,
    originDestinationAirportAriaLabelText,
    flightRoute,
    segmentIndex: segmentUpgrade.segmentIndex
  };
};
const formatText = str => str.trim().replace(/\s+/g, '').toLowerCase();
export const getSegmentUpgradeOptionKey = _ref => {
  let {
    boundIndex,
    segmentIndex,
    optionIndex
  } = _ref;
  return `bound-${boundIndex}-segment-${segmentIndex}-option-${optionIndex}`;
};
export const getAvailablePerks = (perks, upgradeType) => {
  var _perks$find$available, _perks$find;
  return (_perks$find$available = perks === null || perks === void 0 || (_perks$find = perks.find(perk => formatText(perk.upgradeType) === formatText(upgradeType !== null && upgradeType !== void 0 ? upgradeType : ''))) === null || _perks$find === void 0 ? void 0 : _perks$find.availablePerks) !== null && _perks$find$available !== void 0 ? _perks$find$available : [];
};
const SELL_CABIN_UPGRADE_TYPENAME = 'SellCabinUpgrade';
const isSellCabinUpgrade = product => {
  var _product$sellSpecific;
  return ((_product$sellSpecific = product.sellSpecification) === null || _product$sellSpecific === void 0 ? void 0 : _product$sellSpecific.__typename) === SELL_CABIN_UPGRADE_TYPENAME;
};
export const getCabinUpgradeProduct = (productId, order) => {
  const cabinUpgradeProduct = order === null || order === void 0 ? void 0 : order.availableExtraProducts.find(product => String(product.id) === String(productId));
  if (!cabinUpgradeProduct || !isSellCabinUpgrade(cabinUpgradeProduct)) {
    return undefined;
  }
  return cabinUpgradeProduct;
};
export const getTotalTravelerPrice = travelers => (travelers === null || travelers === void 0 ? void 0 : travelers.reduce((sum, traveler) => {
  var _traveler$price$price, _traveler$price;
  return sum + ((_traveler$price$price = traveler === null || traveler === void 0 || (_traveler$price = traveler.price) === null || _traveler$price === void 0 || (_traveler$price = _traveler$price.price) === null || _traveler$price === void 0 ? void 0 : _traveler$price.value) !== null && _traveler$price$price !== void 0 ? _traveler$price$price : 0);
}, 0)) || 0;
export const findCheapestUpgradeOption = availableSegmentUpgrades => {
  var _foundSegmentIndex, _foundBoundIndex, _foundOptionIndex;
  let minTotalPrice = Infinity;
  let cheapestOption = null;
  let foundSegmentIndex;
  let foundBoundIndex;
  let foundOptionIndex;
  availableSegmentUpgrades === null || availableSegmentUpgrades === void 0 || availableSegmentUpgrades.forEach(segmentUpgrade => {
    const {
      upgradeOptions = [],
      boundIndex,
      segmentIndex
    } = segmentUpgrade;
    if (!upgradeOptions.length) {
      return;
    }
    upgradeOptions.forEach((upgradeOption, optionIndex) => {
      var _upgradeOption$travel;
      if (!((_upgradeOption$travel = upgradeOption.travelers) !== null && _upgradeOption$travel !== void 0 && _upgradeOption$travel.length)) {
        return;
      }
      const totalPrice = getTotalTravelerPrice(upgradeOption.travelers);
      if (totalPrice < minTotalPrice) {
        minTotalPrice = totalPrice;
        cheapestOption = upgradeOption;
        foundSegmentIndex = segmentIndex;
        foundBoundIndex = boundIndex;
        foundOptionIndex = optionIndex;
      }
    });
  });
  return {
    upgradeOption: cheapestOption,
    segmentIndex: (_foundSegmentIndex = foundSegmentIndex) !== null && _foundSegmentIndex !== void 0 ? _foundSegmentIndex : null,
    boundIndex: (_foundBoundIndex = foundBoundIndex) !== null && _foundBoundIndex !== void 0 ? _foundBoundIndex : null,
    optionIndex: (_foundOptionIndex = foundOptionIndex) !== null && _foundOptionIndex !== void 0 ? _foundOptionIndex : 0
  };
};
export const getCheapestUpgradeSegment = segmentUpgrade => {
  const availableSegmentUpgrades = segmentUpgrade.filter(upgrade => upgrade.upgradeOptions.length);
  if (!(availableSegmentUpgrades !== null && availableSegmentUpgrades !== void 0 && availableSegmentUpgrades.length)) {
    return {};
  }
  const {
    upgradeOption,
    boundIndex,
    segmentIndex,
    optionIndex
  } = findCheapestUpgradeOption(availableSegmentUpgrades);
  if (typeof boundIndex !== 'number' || typeof segmentIndex !== 'number') {
    return {};
  }
  const upgradeOptionKey = getSegmentUpgradeOptionKey({
    boundIndex,
    segmentIndex,
    optionIndex
  });
  return {
    [upgradeOptionKey]: {
      boundIndex,
      segmentIndex,
      value: upgradeOptionKey,
      upgradeOption
    }
  };
};
export const getSegmentUpgrade = (product, order) => {
  var _product$sellSpecific2;
  const segmentUpgrade = (_product$sellSpecific2 = product.sellSpecification) === null || _product$sellSpecific2 === void 0 || (_product$sellSpecific2 = _product$sellSpecific2.segmentUpgrade) === null || _product$sellSpecific2 === void 0 ? void 0 : _product$sellSpecific2.map(segment => {
    var _segment$boundIndex, _segment$segmentIndex, _segment$upgradeOptio, _foundSegment$duratio;
    const boundId = (_segment$boundIndex = segment === null || segment === void 0 ? void 0 : segment.boundIndex) !== null && _segment$boundIndex !== void 0 ? _segment$boundIndex : 0;
    const segmentIndex = (_segment$segmentIndex = segment === null || segment === void 0 ? void 0 : segment.segmentIndex) !== null && _segment$segmentIndex !== void 0 ? _segment$segmentIndex : 0;
    const bound = order.bounds.find(currentBound => Number(currentBound.boundId) === boundId);
    if (!bound) {
      return null;
    }
    const segments = bound.segments.filter(currentSegment => currentSegment.__typename === 'TripSegment');

    // Subtract 1 since segment indices start at 1 in cabin upgrade product, but bound use 0-based indexing
    const segmentId = segmentIndex - 1;
    const foundSegment = segments === null || segments === void 0 ? void 0 : segments.find(tripSegment => String(tripSegment.segmentId) === `${boundId}${segmentId}`);
    if (!foundSegment) {
      return null;
    }
    const upgradeOptions = ((_segment$upgradeOptio = segment === null || segment === void 0 ? void 0 : segment.upgradeOptions) !== null && _segment$upgradeOptio !== void 0 ? _segment$upgradeOptio : []).map(upgradeOption => {
      var _upgradeOption$travel2;
      return {
        upgradeType: upgradeOption === null || upgradeOption === void 0 ? void 0 : upgradeOption.upgradeType,
        upgradeTypeCode: upgradeOption === null || upgradeOption === void 0 ? void 0 : upgradeOption.upgradeTypeCode,
        travelers: ((_upgradeOption$travel2 = upgradeOption === null || upgradeOption === void 0 ? void 0 : upgradeOption.travelers) !== null && _upgradeOption$travel2 !== void 0 ? _upgradeOption$travel2 : []).map(traveler => {
          var _traveler$price$price2, _traveler$price2, _traveler$travelerId;
          return {
            price: {
              price: {
                value: (_traveler$price$price2 = traveler === null || traveler === void 0 || (_traveler$price2 = traveler.price) === null || _traveler$price2 === void 0 || (_traveler$price2 = _traveler$price2.price) === null || _traveler$price2 === void 0 ? void 0 : _traveler$price2.value) !== null && _traveler$price$price2 !== void 0 ? _traveler$price$price2 : 0
              }
            },
            travelerId: (_traveler$travelerId = traveler === null || traveler === void 0 ? void 0 : traveler.travelerId) !== null && _traveler$travelerId !== void 0 ? _traveler$travelerId : 0
          };
        })
      };
    });
    return {
      boundIndex: boundId,
      segmentIndex,
      destination: foundSegment.destination,
      origin: foundSegment.origin,
      duration: (_foundSegment$duratio = foundSegment.duration) !== null && _foundSegment$duratio !== void 0 ? _foundSegment$duratio : null,
      upgradeOptions: upgradeOptions || []
    };
  }).filter(v => typeof v === 'object' && v !== null);
  return segmentUpgrade;
};
export const getSegmentUpgradePrice = segmentUpgradeTravelers => {
  return segmentUpgradeTravelers !== null && segmentUpgradeTravelers !== void 0 && segmentUpgradeTravelers.length ? segmentUpgradeTravelers.map(travelerPrices => {
    const total = travelerPrices.map(priceDetails => {
      var _priceDetails$price;
      return priceDetails === null || priceDetails === void 0 || (_priceDetails$price = priceDetails.price) === null || _priceDetails$price === void 0 || (_priceDetails$price = _priceDetails$price.price) === null || _priceDetails$price === void 0 ? void 0 : _priceDetails$price.value;
    }).filter(v => typeof v === 'number').reduce((sum, val) => sum + val, 0);
    return total;
  }) : [];
};
export const getSegmentUpgradePricePerTraveler = travelerPrices => {
  const numberOfTravelers = travelerPrices === null || travelerPrices === void 0 ? void 0 : travelerPrices.length;
  if (numberOfTravelers) {
    const totalTravelerPrice = getTotalTravelerPrice(travelerPrices);
    const averagePricePerTraveler = totalTravelerPrice / numberOfTravelers;
    return averagePricePerTraveler;
  }
  return undefined;
};
export const minimumSegmentUpgradeTotalPrice = segmentUpgrade => {
  const cheapestAvailableUpgradeSegments = getCheapestUpgradeSegment(segmentUpgrade);
  const segmentUpgradeTravelers = Object.values(cheapestAvailableUpgradeSegments).map(cheapestSegment => {
    var _cheapestSegment$upgr, _cheapestSegment$upgr2;
    return (_cheapestSegment$upgr = cheapestSegment === null || cheapestSegment === void 0 || (_cheapestSegment$upgr2 = cheapestSegment.upgradeOption) === null || _cheapestSegment$upgr2 === void 0 ? void 0 : _cheapestSegment$upgr2.travelers) !== null && _cheapestSegment$upgr !== void 0 ? _cheapestSegment$upgr : [];
  }).filter(Boolean);
  const segmentUpgradePrice = getSegmentUpgradePrice(segmentUpgradeTravelers);
  const minTotalPrice = segmentUpgradePrice === null || segmentUpgradePrice === void 0 ? void 0 : segmentUpgradePrice.reduce((acc, currentValue) => acc + currentValue, 0);
  return minTotalPrice;
};
export const selectedSegmentUpgradeTotalPrice = selectedUpgrades => {
  const segmentUpgradeTravelers = selectedUpgrades === null || selectedUpgrades === void 0 ? void 0 : selectedUpgrades.map(upgrade => {
    var _upgrade$upgradeOptio, _upgrade$upgradeOptio2;
    return (_upgrade$upgradeOptio = upgrade === null || upgrade === void 0 || (_upgrade$upgradeOptio2 = upgrade.upgradeOption) === null || _upgrade$upgradeOptio2 === void 0 ? void 0 : _upgrade$upgradeOptio2.travelers) !== null && _upgrade$upgradeOptio !== void 0 ? _upgrade$upgradeOptio : [];
  }).filter(Boolean);
  const segmentUpgradePrice = getSegmentUpgradePrice(segmentUpgradeTravelers);
  const totalPrice = segmentUpgradePrice === null || segmentUpgradePrice === void 0 ? void 0 : segmentUpgradePrice.reduce((acc, currentValue) => acc + currentValue, 0);
  return totalPrice;
};
export const getSelectedUpgrades = (form, name, state) => {
  var _formData$value$selec, _formData$value;
  const formData = formValueSelector(form)(state, name);
  const value = (_formData$value$selec = formData === null || formData === void 0 || (_formData$value = formData.value) === null || _formData$value === void 0 ? void 0 : _formData$value.selectedUpgrades) !== null && _formData$value$selec !== void 0 ? _formData$value$selec : [];
  return value;
};
export const getUnselectedUpgrades = (form, name, state) => {
  var _formData$value$unsel, _formData$value2;
  const formData = formValueSelector(form)(state, name);
  const value = (_formData$value$unsel = formData === null || formData === void 0 || (_formData$value2 = formData.value) === null || _formData$value2 === void 0 ? void 0 : _formData$value2.unselectedUpgrades) !== null && _formData$value$unsel !== void 0 ? _formData$value$unsel : {};
  return value;
};
export const isUpgradeSaved = (form, name, state) => {
  const selectedUpgrades = getSelectedUpgrades(form, name, state);
  return selectedUpgrades.length > 0;
};
export const isProductSelected = (form, name, state) => {
  var _formData$value3;
  const formData = formValueSelector(form)(state, name);
  const value = formData === null || formData === void 0 || (_formData$value3 = formData.value) === null || _formData$value3 === void 0 ? void 0 : _formData$value3.value;
  return value === 'true';
};
export const setNoThanksButtonFocus = () => {
  setTimeout(() => {
    const noThanksButton = document.getElementById(`${CABIN_UPGRADE.name}_false`);
    noThanksButton === null || noThanksButton === void 0 || noThanksButton.focus();
  }, 800);
};
export const setAddToCartButtonFocus = () => {
  setTimeout(() => {
    const addToCartButton = document.getElementById(`${CABIN_UPGRADE.name}_true`);
    addToCartButton === null || addToCartButton === void 0 || addToCartButton.focus();
  }, 800);
};
//# sourceMappingURL=utils.js.map